import { For, Show } from "solid-js";
import { currentUser, logout } from "../core/session";
import type { TabRecord } from "../core/views";
import { DumpIcon } from "./DumpIcon";
import { Notifications } from "./Notifications";

type TopbarProps = {
  tabs: TabRecord[];
  activeTabId: number;
  onSelect: (id: number) => void;
  onClose: (id: number) => void;
  onNew: () => void;
  onSettings: () => void;
};

export function Topbar(props: TopbarProps) {
  return (
    <header class="flex h-10 w-full justify-between">
      <ul class="top-nav xscroll flex h-full w-[80%] gap-2 overflow-x-auto pr-4">
        <For each={props.tabs}>
          {(tab, index) => (
            <li
              class="group relative flex h-full min-w-[8.5rem] skew-x-[8deg] first:skew-x-[0deg]"
            >
              <button
                class="relative flex w-full cursor-pointer items-center justify-center transition-all duration-200 ease-in-out before:absolute before:bottom-0 before:left-0 before:h-[2px] before:bg-cyan"
                classList={{
                  "bg-[rgba(255,255,255,.2)] before:w-[40%]":
                    tab.id === props.activeTabId,
                  "bg-[rgba(255,255,255,.08)] before:w-0":
                    tab.id !== props.activeTabId,
                }}
                onClick={() => props.onSelect(tab.id)}
              >
                <span
                  class="capitalize"
                  classList={{ "skew-x-[-8deg]": index() !== 0 }}
                >
                  {tab.title}
                </span>
              </button>

              <button
                class="ml-[-0.25rem] flex w-9 cursor-pointer items-center justify-center bg-[rgb(98,98,98)] transition-all duration-200 ease-in-out hover:bg-cyan hover:text-black-54"
                classList={{ "skew-x-[8deg]": index() === 0 }}
                aria-label={`Close ${tab.title}`}
                onClick={() => props.onClose(tab.id)}
              >
                <span class="mt-[-3px] scale-x-[1.4] scale-y-[0.9]">x</span>
              </button>
            </li>
          )}
        </For>

        <li class="active-shadow ml-1 flex w-8 shrink-0 skew-x-[8deg] cursor-pointer items-center justify-center bg-cyan text-black-54">
          <button
            class="flex h-full w-full items-center justify-center"
            aria-label="New tab"
            onClick={props.onNew}
          >
            <span class="mt-[-3px] rotate-45 scale-x-[1.4] scale-y-[0.9] transition-all duration-200 ease-in-out hover:rotate-[225deg]">
              x
            </span>
          </button>
        </li>
      </ul>

      <div class="flex h-8 items-center gap-2">
        <Notifications />
        <div class="group item-list-bg bg-gray-gradient relative flex h-8 items-center justify-between">
          <img
            class="mr-2 h-8"
            src={
              currentUser()?.profilePicture ||
              "https://assets.nopixel.net/dev/images/mdt/mdt_no_profile_picture.png"
            }
            alt=""
          />
          <p>
            {currentUser()?.firstName ?? "No"}{" "}
            {currentUser()?.lastName ?? "User"}
          </p>
          <div class="mx-2 flex h-5 items-center justify-center gap-3 bg-cyan px-1">
            <p class="text-black-74">{currentUser()?.callsign ?? "N/A"}</p>
          </div>
          <div class="bg-gray-gradient absolute left-0 top-8 z-50 hidden w-full flex-col items-start justify-between group-hover:flex">
            <button
              class="item-list-bg bg-gray-gradient relative flex w-full items-center gap-2 px-3 py-2"
              onClick={props.onSettings}
            >
              <DumpIcon name="nav_config" />
              <span class="text-sm">User Settings</span>
            </button>
            <button
              class="item-list-bg bg-gray-gradient relative flex w-full items-center gap-2 px-3 py-2"
              onClick={logout}
            >
              <DumpIcon name="logout" />
              <span class="text-sm">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
